// Brand symbols that users can add to their horse cards
export const BRAND_SYMBOLS = [
  {
    id: 'symbol_0',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/w8wr60gx_Symbol_0.png.png',
    name: 'Symbol 1'
  },
  {
    id: 'symbol_1',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/cs6q1b9x_Symbol_1.png.png',
    name: 'Symbol 2'
  },
  {
    id: 'symbol_2',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/897nk610_Symbol_2.png.png',
    name: 'Symbol 3'
  },
  {
    id: 'symbol_3',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/sy1lqj33_Symbol_3.png.png',
    name: 'Symbol 4'
  },
  {
    id: 'symbol_4',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/fjn2xg1d_Symbol_4.png.png',
    name: 'Symbol 5'
  },
  {
    id: 'symbol_5',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/mdh5m32x_Symbol_5.png.png',
    name: 'Symbol 6'
  },
  {
    id: 'symbol_6',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/z3iqtokj_Symbol_6.png.png',
    name: 'Symbol 7'
  },
  {
    id: 'symbol_7',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/187keri7_Symbol_7.png.png',
    name: 'Symbol 8'
  },
  {
    id: 'symbol_8',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/xa3it0dt_Symbol_8.png.png',
    name: 'Symbol 9'
  },
  {
    id: 'symbol_9',
    url: 'https://customer-assets.emergentagent.com/job_horsecare-app-1/artifacts/p52w9z6g_Symbol_9.png.png',
    name: 'Symbol 10'
  }
];

// Default form structure for new/editing horses
export const DEFAULT_HORSE_FORM = {
  name: '',
  tag_number: '',
  age: '',
  gender: '',
  color: '',
  hma: '',
  height: '',
  disposition: '',
  photo_url: '',
  brand_symbols: [],
  bonding_level: 0,
  last_care_date: null,
  gentling: {
    first_touch: {
      approach_shoulder: false,
      accept_shoulder_withers: false,
      accept_neck: false,
      accept_face: false
    },
    halter: {
      introduce_halter: false,
      slip_over_neck: false,
      slip_nose_band: false,
      put_on_and_tie: false
    },
    attach_lead_rope: {
      introduce_lead_rope: false,
      attach_lead_rope: false
    },
    leading: {
      light_pressure_face: false,
      first_steps: false,
      leading_circle: false,
      leading_straight: false
    },
    desensitization: {
      flag: false,
      pool_noodle: false,
      tarp: false,
      water_hose: false
    },
    grooming: {
      currying: false,
      soft_brush: false,
      comb_mane_forelock: false,
      brush_tail: false,
      pick_feet: false
    },
    tying: {
      pressure_on_face: false,
      tie_blocker: false,
      hard_tie: false
    },
    picking_up_feet: {
      left_front: false,
      right_front: false,
      left_hind: false,
      right_hind: false
    },
    trailer_loading: {
      intro_to_trailer: false,
      load_front_feet: false,
      load_entirely: false,
      back_off: false,
      turn_around_step_off: false
    }
  },
  daily_care_checklist: {
    grain: {
      am: false,
      pm: false
    },
    supplements: {
      am: false,
      pm: false
    },
    hay: {
      am: false,
      pm: false
    },
    water: {
      am_clean: false,
      pm_clean: false
    },
    grooming: {
      currying_face: false,
      currying_body: false,
      currying_legs: false,
      brush_face: false,
      brush_body: false,
      brush_legs: false,
      comb_mane_forelock: false,
      brush_tail: false,
      pick_feet: false
    }
  },
  grooming: '',
  groundwork: '',
  daily_feeding: ''
};

// Gentling checklist configuration
export const GENTLING_CATEGORIES = [
  {
    key: 'first_touch',
    label: 'First Touch',
    items: [
      { key: 'approach_shoulder', label: 'Approach at the shoulder' },
      { key: 'accept_shoulder_withers', label: 'Accept touch at shoulder + withers' },
      { key: 'accept_neck', label: 'Accept up the neck' },
      { key: 'accept_face', label: 'Accept touch on the face' }
    ]
  },
  {
    key: 'halter',
    label: 'Halter',
    items: [
      { key: 'introduce_halter', label: 'Introduce halter' },
      { key: 'slip_over_neck', label: 'Practice slipping halter over neck' },
      { key: 'slip_nose_band', label: 'Practice slipping nose band on/off' },
      { key: 'put_on_and_tie', label: 'Putting on halter + tying' }
    ]
  },
  {
    key: 'attach_lead_rope',
    label: 'Attach Lead Rope',
    items: [
      { key: 'introduce_lead_rope', label: 'Introduce lead rope' },
      { key: 'attach_lead_rope', label: 'Attach lead rope' }
    ]
  },
  {
    key: 'leading',
    label: 'Leading',
    items: [
      { key: 'light_pressure_face', label: 'Light pressure on face' },
      { key: 'first_steps', label: 'First steps' },
      { key: 'leading_circle', label: 'Leading in a circle' },
      { key: 'leading_straight', label: 'Leading straight line' }
    ]
  },
  {
    key: 'desensitization',
    label: 'Desensitization',
    items: [
      { key: 'flag', label: 'Flag' },
      { key: 'pool_noodle', label: 'Pool noodle' },
      { key: 'tarp', label: 'Tarp' },
      { key: 'water_hose', label: 'Water hose' }
    ]
  },
  {
    key: 'grooming',
    label: 'Grooming',
    items: [
      { key: 'currying', label: 'Currying' },
      { key: 'soft_brush', label: 'Soft brush' },
      { key: 'comb_mane_forelock', label: 'Comb mane + forelock' },
      { key: 'brush_tail', label: 'Brush tail' },
      { key: 'pick_feet', label: 'Pick feet' }
    ]
  },
  {
    key: 'tying',
    label: 'Tying',
    items: [
      { key: 'pressure_on_face', label: 'Pressure on face' },
      { key: 'tie_blocker', label: 'Tie blocker' },
      { key: 'hard_tie', label: 'Hard tie' }
    ]
  },
  {
    key: 'picking_up_feet',
    label: 'Picking Up Feet',
    items: [
      { key: 'left_front', label: 'Left front' },
      { key: 'right_front', label: 'Right front' },
      { key: 'left_hind', label: 'Left hind' },
      { key: 'right_hind', label: 'Right hind' }
    ]
  },
  {
    key: 'trailer_loading',
    label: 'Trailer Loading',
    items: [
      { key: 'intro_to_trailer', label: 'Intro to trailer' },
      { key: 'load_front_feet', label: 'Load front feet' },
      { key: 'load_entirely', label: 'Load entirely' },
      { key: 'back_off', label: 'Back off' },
      { key: 'turn_around_step_off', label: 'Turn around + step off' }
    ]
  }
];

// Daily care checklist configuration
export const DAILY_CARE_CATEGORIES = [
  {
    key: 'grain',
    label: 'Grain',
    items: [
      { key: 'am', label: 'AM' },
      { key: 'pm', label: 'PM' }
    ]
  },
  {
    key: 'supplements',
    label: 'Supplements',
    items: [
      { key: 'am', label: 'AM' },
      { key: 'pm', label: 'PM' }
    ]
  },
  {
    key: 'hay',
    label: 'Hay',
    items: [
      { key: 'am', label: 'AM' },
      { key: 'pm', label: 'PM' }
    ]
  },
  {
    key: 'water',
    label: 'Water',
    items: [
      { key: 'am_clean', label: 'AM Clean' },
      { key: 'pm_clean', label: 'PM Clean' }
    ]
  },
  {
    key: 'grooming',
    label: 'Grooming',
    items: [
      { key: 'currying_face', label: 'Currying face' },
      { key: 'currying_body', label: 'Currying body' },
      { key: 'currying_legs', label: 'Currying legs' },
      { key: 'brush_face', label: 'Brush face' },
      { key: 'brush_body', label: 'Brush body' },
      { key: 'brush_legs', label: 'Brush legs' },
      { key: 'comb_mane_forelock', label: 'Comb mane + forelock' },
      { key: 'brush_tail', label: 'Brush tail' },
      { key: 'pick_feet', label: 'Pick feet' }
    ]
  }
];

// Bonding system constants
export const BONDING_CONFIG = {
  MIN_LEVEL: 0,
  MAX_LEVEL: 100,
  STARTING_LEVEL: 0,
  POINTS_PER_TASK: 2,
  DECAY_PERCENTAGE: 10, // 10% decay per missed day
  MIN_COMPLETION_PERCENTAGE: 50 // Must complete 50% of daily tasks to prevent decay
};

// App colors
export const THEME_COLORS = {
  primary: '#D66238',
  secondary: '#6FCFD3',
  background: '#FCFCF8'
};
